import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import zIndexScale from '../../utils/zIndexScale'


import { getLabel } from '../../utils/i18n';

const IndPanel = styled.div`
  display: flex;
  visibility: ${({ hidden }) => hidden ? 'hidden' : 'visible'};
  align-items: center;
  padding:6px;
  position:absolute;
  top:20px;
  left:0;
  background:${({ theme }) => theme.buttonbg};
  color: ${({ theme }) => theme.fontColor};
  opacity:  ${({ hidden }) => hidden ? 0 : 1};
  transition: visibility 0.3s, opacity .3s;
  z-index:${zIndexScale.dropdown};
  font-family: ${({ theme }) => theme.fontIBMRegular};
  white-space:nowrap;
  align-items: flex-start;
  & > ul {
    flex-flow: column || nowrap;

  }
  & >ul >li{
    display:flex;
    padding:3px 20px;
    & :hover{
      color: ${({ theme }) => theme.chartButtonColorActive || ''};
    }
  }
`;

export default
class IndicatorPanelComponent extends PureComponent {
  static propTypes = {
    indicators: PropTypes.array,
    hidden: PropTypes.bool,
    onRowClick: PropTypes.func,
    i18n: PropTypes.object,
  };

  static defaultProps = {
    indicators: [],
    hidden: false,
    i18n:{},
    onRowClick:()=>{},
  }
  render(){
    const colCount =2 ;
    const { hidden, indicators, i18n, i18nShow, } = this.props;
    return (
      <IndPanel hidden={hidden} onClick={(ev) => { ev.stopPropagation(); }} role="menuitem" onKeyDown={(ev) => { ev.stopPropagation(); }}>
       { [1,2].map((col, i)=>(
	  <ul key={i}>
	    {indicators.map((row ,j)=>(
	      (j % colCount===i)?
		<li key={row.value} onClick={() => { this.props.onRowClick(row.value); }} role="menuitem" onKeyDown={() => { this.onRowClick(row.value); }}>{getLabel(row.display, i18n)}</li>:
		null
	    ))}
	  </ul>
      ))}
    </IndPanel>
    )

  }

}
